import React from 'react';
import WrapperSection from '../../components/global/WrapperSection';
import GlobalBreadcrumbs from '../../components/global/GlobalBreadcrumbs';
import GuardiansTable from '../../components/guardians/GuardiansTable';
const Guardians = () => (<WrapperSection><GlobalBreadcrumbs /><GuardiansTable /></WrapperSection>);
export default Guardians;
